<template>
	<div class="item">
		<div class="date" v-text="date"/>

		<div class="line">
			<div class="title">Ordrenummer #{{number}}</div>
			<div class="price">DKK {{price}}</div>
		</div>

		<router-link class="link" :to="{name: 'order', params: {id}}">
			Se ordre
			<div class="icon" v-html="require('@/assets/icons/long-arrow-right.svg')"/>
		</router-link>
	</div>
</template>

<script>
import {date, price} from "@/modules/utils";

export default {
	props: {
		id: {type: Number, required: true},
		number: {type: String, required: true},
		total_price: {type: Number, required: true},
		confirmed_at: {type: Number, required: true}
	},
	computed: {
		price: (t) => price(t.total_price),
		date() {
			const d = date(this.confirmed_at);
			return `${d.day}-${d.month}-${d.year}`;
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	border-top: 1px solid #E5E9ED;
	padding: 30px 0;

	.date {
		font-size: 12px;
		color: #303C49;
		opacity: 0.4;
		font-weight: 500;
		letter-spacing: 1px;
		margin-bottom: 10px;
	}

	.line {
		font-size: 18px;
		font-weight: 500;
		color: #363B40;

		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.title, .price {
		margin-bottom: 24px;
	}

	.title {
		margin-right: 2em;
	}

	.link {
		display: flex;
		align-items: center;
		color: #007ACE;
		font-size: 14px;

		.icon {
			display: inline-flex;
			margin-left: 0.5em;
			margin-bottom: -2px;

			/deep/ svg {
				$s: 14px;
				width: $s;
				height: $s;

				path {
					fill: #007ACE;
				}
			}
		}
	}
}
</style>
